import { getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';

export const LEASE_DEALS_BREADCRUMBS = [getHomeBreadcrumb(), { title: 'Lease Deals' }];
